module.exports = __webpack_public_path__ + "img/icon3.b780f2d5.png";